module.exports = __webpack_public_path__ + "static/media/my-profile-inactive-vector.5866fca0.svg";